import React from 'react';
import './Service.css'
import webDesign from './../../../Images/webdesign-3411373_640.jpg'
import webDevelopment from './../../../Images/web-development-1928238_640.png'
import responsive from './../../../Images/interface-3614766_640.png'
import Fade from 'react-reveal/Fade';
const Services = () => {
    return (
        <section id="team" className="pb-5">
            <div className="container">
                <div className="row">
                    <h3 className=""><span style={{ borderBottom: '3px solid green' }}>MY SERVICES</span></h3>
                    <div className="col-xs-12 col-sm-6 col-md-4 mt-5">
                        <div className="image-flip" ontouchstart="this.classNameList.toggle('hover');">
                            <div className="mainflip">
                                <div className="frontside">
                                    <Fade left>
                                        <div className="card">
                                            <div className="card-body text-center">
                                                <p><img src={webDesign} className="card-img-top img-fluid card-img" alt="..." /></p>
                                                <h4 className="card-title">Web Design</h4>
                                                <p className="card-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo, libero.</p>
                                                <a href="#" className="btn btn-primary btn-sm mt-3"><i className="fa fa-plus"></i></a>
                                            </div>
                                        </div>
                                    </Fade>
                                </div>
                                <div className="backside">
                                    <div className="card">
                                        <div className="card-body text-center mt-4">
                                            <h4 className="card-title">Web Design</h4>
                                            <p className="card-text mt-5">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Fuga, at earum dolorem nulla consequuntur repudiandae.</p>
                                            <ul className="list-inline mt-5">
                                                <li className="list-inline-item">
                                                    <a className="social-icon text-xs-center" href="https://www.facebook.com/princeboy.rd.9">
                                                        <i className="fab fa-facebook"></i>
                                                    </a>
                                                </li>
                                                <li className="list-inline-item">
                                                    <a className="social-icon text-xs-center" href="https://www.linkedin.com/in/raj-dev-ullash-831512203/">
                                                        <i className="fab fa-linkedin"></i>
                                                    </a>
                                                </li>
                                                <li className="list-inline-item">
                                                    <a className="social-icon text-xs-center" href="https://github.com/Rajdev-ullash">
                                                        <i className="fab fa-github"></i>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xs-12 col-sm-6 col-md-4 mt-5">
                        <div className="image-flip" ontouchstart="this.classNameList.toggle('hover');">
                            <div className="mainflip">
                                <div className="frontside">
                                    <Fade bottom>
                                        <div className="card">
                                            <div className="card-body text-center">
                                                <p><img src={webDevelopment} className="card-img-top img-fluid card-img" alt="..." /></p>
                                                <h4 className="card-title">Web Development</h4>
                                                <p className="card-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo, libero.</p>
                                                <a href="#" className="btn btn-primary btn-sm mt-3"><i className="fa fa-plus"></i></a>
                                            </div>
                                        </div>
                                    </Fade>
                                </div>
                                <div className="backside">
                                    <div className="card">
                                        <div className="card-body text-center mt-4">
                                            <h4 className="card-title">Web Development</h4>
                                            <p className="card-text mt-5">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Fuga, at earum dolorem nulla consequuntur repudiandae.</p>
                                            <ul className="list-inline mt-5">
                                                <li className="list-inline-item">
                                                    <a className="social-icon text-xs-center" href="https://www.facebook.com/princeboy.rd.9">
                                                        <i className="fab fa-facebook"></i>
                                                    </a>
                                                </li>
                                                <li className="list-inline-item">
                                                    <a className="social-icon text-xs-center" href="https://www.linkedin.com/in/raj-dev-ullash-831512203/">
                                                        <i className="fab fa-linkedin"></i>
                                                    </a>
                                                </li>
                                                <li className="list-inline-item">
                                                    <a className="social-icon text-xs-center" href="https://github.com/Rajdev-ullash">
                                                        <i className="fab fa-github"></i>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xs-12 col-sm-6 col-md-4 mt-5">
                        <div className="image-flip" ontouchstart="this.classNameList.toggle('hover');">
                            <div className="mainflip">
                                <div className="frontside">
                                    <Fade right>
                                        <div className="card">
                                            <div className="card-body text-center">
                                                <p><img src={responsive} className="card-img-top img-fluid card-img" alt="..." /></p>
                                                <h4 className="card-title">Responsive Design</h4>
                                                <p className="card-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo, libero.</p>
                                                <a href="#" className="btn btn-primary btn-sm mt-3"><i className="fa fa-plus"></i></a>
                                            </div>
                                        </div>
                                    </Fade>
                                </div>
                                <div className="backside">
                                    <div className="card">
                                        <div className="card-body text-center mt-4">
                                            <h4 className="card-title">Responsive Design</h4>
                                            <p className="card-text mt-5">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Fuga, at earum dolorem nulla consequuntur repudiandae.</p>
                                            <ul className="list-inline mt-5">
                                                <li className="list-inline-item">
                                                    <a className="social-icon text-xs-center" href="https://www.facebook.com/princeboy.rd.9">
                                                        <i className="fab fa-facebook"></i>
                                                    </a>
                                                </li>
                                                <li className="list-inline-item">
                                                    <a className="social-icon text-xs-center" href="https://www.linkedin.com/in/raj-dev-ullash-831512203/">
                                                        <i className="fab fa-linkedin"></i>
                                                    </a>
                                                </li>
                                                <li className="list-inline-item">
                                                    <a className="social-icon text-xs-center" href="https://github.com/Rajdev-ullash">
                                                        <i className="fab fa-github"></i>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </section>
    );
};

export default Services;